import { request } from '@/shared/api';
import { withScopeQuery } from '@/shared/model/agent-scope';
export function fetchEngagementBoard(trajectoryCode, scope) {
    const params = new URLSearchParams();
    if (trajectoryCode)
        params.set('trajectoryCode', trajectoryCode);
    params.set('includeCompleted', 'true');
    const query = params.toString();
    const path = `/api/v1/engagements/board?${query}`;
    return request(withScopeQuery(path, scope));
}
export function fetchTrajectories() {
    return request('/api/v1/trajectories');
}
export function fetchEngagement(engagementId) {
    return request(`/api/v1/engagements/${engagementId}`);
}
export function createEngagement(input) {
    return request('/api/v1/engagements', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function advanceEngagement(engagementId, note) {
    return request(`/api/v1/engagements/${engagementId}/advance`, {
        method: 'POST',
        body: JSON.stringify({ note }),
    });
}
export function cancelEngagement(engagementId, reason) {
    return request(`/api/v1/engagements/${engagementId}/cancel`, {
        method: 'POST',
        body: JSON.stringify({ reason }),
    });
}
export function updateTrajectoryStages(trajectoryCode, stages) {
    return request(`/api/v1/trajectories/${encodeURIComponent(trajectoryCode)}/stages`, {
        method: 'PUT',
        body: JSON.stringify({ stages }),
    });
}
